export default function () {
    // intersection observer for animations
    const animatedElements = document.querySelectorAll('.will-animate');
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
            for (let i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    if (entries[i].target.classList.contains('will-animate--desktops-only') && window.matchMedia('(max-width: 1079px)').matches) {
                        continue;
                    }

                    entries[i].target.classList.add(entries[i].target.getAttribute('data-animation'));
                    observer.unobserve(entries[i].target);
                }
            }
        });

        for (let i = 0; i < animatedElements.length; i++) {
            observer.observe(animatedElements[i]);
        }
    } else {
        for (let i = 0; i < animatedElements.length; i++) {
            animatedElements[i].classList.remove('will-animate');
        }
    }
}
